<template>
  <div class="overlayWindow">
    <div class="content">
      <h2>
        <slot name="title"></slot>
      </h2>
      <slot></slot>
      <div class="actions">
        <slot name="actions">
          <button v-on:click.prevent="close()">OK</button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'overlayWindow',
  methods: {
    close() {
      this.$emit('done')
    },
  },
}
</script>

<style lang="scss" scoped>
.overlayWindow:before {
  content: '';
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
.overlayWindow {
  position: fixed;
  display: flex;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  justify-content: center;
  align-items: center;
}
.content {
  z-index: 100;
  max-width: 60em;
  background: white;
  border: 2px solid var(--primary);
  padding: calc(var(--sp) * 3);
  z-index: 2;
  text-align: center;
  max-height: 100vh;
  overflow-y: auto;
}

.actions {
  margin-top: calc(var(--sp) * 3);
  margin-bottom: calc(var(--sp) * 3);
  text-align: center;
  button {
    min-width: 8em !important;
  }
}
</style>
